import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-search-title" }
const _hoisted_2 = {
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "search-title"
}
const _hoisted_3 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createTextVNode(_toDisplayString($props.title) + " ", 1 /* TEXT */),
      _createElementVNode("span", {
        class: "_tc--dark-gray _fw-n _fa--xs _whs-nw",
        "data-qa": `search-count:${$props.totalItemCount}`
      }, "(" + _toDisplayString($options.searchCountLabel) + ")", 9 /* TEXT, PROPS */, _hoisted_3)
    ])
  ]))
}